(function () {
    'use strict';

    angular
        .module('app')
        .controller('FooterCtrl', ['appData', FooterCtrl]);

    function FooterCtrl(appData) {
        var vm = this;

        vm.showBuildNumber = appData.trackingVersion === 'stage';
        vm.buildNumber = appData.buildNumber;
    };

})();